module.exports = {"Operate21":{"daobanList":[{"title":"是否申报建筑业企业资质核准（施工劳务资质)","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"建筑业企业资质申请表","state":"必要"},{"name":"《企业法定代表人声明》","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-21.json
// module id = 1279
// module chunks = 0